export const messages = {
  en: {
    reportCustomComponentRelManage: {
      title: 'Report Custom Component Relation Management',
      relId: 'Relation ID',
      componentName: 'Component Name',
      customId: 'Report ID',
      seq: 'Sequence',
      createTime: 'Create Time',
      associateComponent: 'Associate Component',
      fetchError: 'Failed to fetch component relations'
    },
    addReportCustomComponentRel: {
      title: 'Add Component Relation',
      component: 'Component',
      seq: 'Sequence',
      chooseComponent: 'Choose Component',
      componentRequired: 'Component is required',
      seqRequired: 'Sequence is required',
      seqMustNumber: 'Sequence must be number',
      saveSuccess: 'Save successfully',
      saveError: 'Failed to save'
    },
    chooseReportCustomComponent: {
      title: 'Choose Report Component',
      searchPlaceholder: 'Input component name',
      componentId: 'Component ID',
      componentName: 'Component Name',
      componentType: 'Component Type',
      queryModel: 'Query Model',
      remark: 'Remark',
      fetchError: 'Failed to fetch components'
    },
    deleteReportCustomComponentRel: {
      title: 'Confirm Delete',
      confirmMessage: 'Are you sure to delete this component relation?',
      deleteSuccess: 'Delete successfully',
      deleteError: 'Failed to delete'
    }
  },
  zh: {
    reportCustomComponentRelManage: {
      title: '报表自定义组件关系管理',
      relId: '关系编号',
      componentName: '组件名称',
      customId: '报表编号',
      seq: '组件序号',
      createTime: '关联时间',
      associateComponent: '关联组件',
      fetchError: '获取组件关系失败'
    },
    addReportCustomComponentRel: {
      title: '添加组件关系',
      component: '组件',
      seq: '组件序号',
      chooseComponent: '选择组件',
      componentRequired: '组件不能为空',
      seqRequired: '组件序号不能为空',
      seqMustNumber: '组件序号必须为数字',
      saveSuccess: '保存成功',
      saveError: '保存失败'
    },
    chooseReportCustomComponent: {
      title: '选择报表组件',
      searchPlaceholder: '输入报表组件名称',
      componentId: '组件ID',
      componentName: '组件名称',
      componentType: '组件类型',
      queryModel: '查询方式',
      remark: '描述',
      fetchError: '获取组件列表失败'
    },
    deleteReportCustomComponentRel: {
      title: '确认删除',
      confirmMessage: '确定删除该组件关系吗？',
      deleteSuccess: '删除成功',
      deleteError: '删除失败'
    }
  }
}